import * as React from 'react';
import { Input } from '@/components/ui/input';
import { formatInteger } from '@/lib/format/number';
import { parseClpInput } from '@/lib/format/currency';
import { cn } from '@/lib/utils/cn';

export interface ClpInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value?: number;
  onChange?: (value: number) => void;
}

export const ClpInput = React.forwardRef<HTMLInputElement, ClpInputProps>(
  ({ value, onChange, className, ...props }, ref) => {
    const display = value === undefined || Number.isNaN(value) ? '' : formatInteger(value);
    return (
      <div className="relative">
        <span
          aria-hidden
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 font-display text-sm text-[var(--color-ink-muted)]"
        >
          $
        </span>
        <Input
          ref={ref}
          inputMode="numeric"
          autoComplete="off"
          className={cn('pl-7 tabular', className)}
          value={display}
          onChange={(e) => {
            onChange?.(parseClpInput(e.target.value));
          }}
          {...props}
        />
      </div>
    );
  },
);
ClpInput.displayName = 'ClpInput';
